module.exports = __webpack_public_path__ + "static/media/bullet-white.236aea1c.svg";